import {createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import "./App.css";
import Layout from "./Components/Layout/Layout";
import Home from "./Components/Home/Home";
import AboutUs from "./Components/AboutUs/AboutUs";
import Services from "./Components/Services/Services";
import Blogs from "./Components/Blogs/Blogs";
import Contact from "./Components/Contact/Contact";
import FullBlog from "./Components/Blogs/FullBlog";
import { useEffect, useState } from "react";
import { DirectionContext } from "./Components/Contexts/DirectionContext";
import { useTranslation } from "react-i18next";
import NotFound from "./Components/NotFound";
import { BlogProvider } from "./Components/Contexts/BlogContext";
import { QueryClient, QueryClientProvider } from "react-query";

function App() {
  const [dir, setDir] = useState("ltr");
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== "en") {
      i18n.changeLanguage("en");
    }
  }, [i18n]);

  useEffect(() => {
    document.body.dir = dir;
  }, [dir]);

  const queryClient = new QueryClient();

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        { index: true, element: <Navigate to="/home" /> },
        { path: "home", element: <Home /> },
        { path: "info/AboutUs", element: <AboutUs /> },
        { path: "info/services", element: <Services /> },
        { path: "info/", element: <AboutUs /> },
        { path: "info/Blogs", element: <Blogs /> },
        { path: "info/contact", element: <Contact /> },
        { path: "info/FullBlog/:id", element: <FullBlog /> },
        { path: "*", element: <NotFound /> },
      ],
    },
  ]);

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <DirectionContext.Provider value={{ dir, setDir }}>
          <BlogProvider>
            <RouterProvider router={router} 
            defaultPreload="intent"
        />
          </BlogProvider>
        </DirectionContext.Provider>
      </QueryClientProvider>
    </>
  );
}

export default App;
